export const locales = ['pt-BR', 'en'] as const;

export const fallbackLocale = 'pt-BR';
export const localeCookieName = 'locale';

export type AppLocale = (typeof locales)[number];

export function hasLocale(locale: string): locale is AppLocale {
  return locales.includes(locale as AppLocale);
}
